module.exports = __webpack_public_path__ + "media/images/riders/small/MICHAEL_JONES-a848ff9ce93e205c3b33055ce8a4d3c8.png";